import { render } from "./ChartReport.vue?vue&type=template&id=40bf485e&scoped=true"
import script from "./ChartReport.vue?vue&type=script&lang=js"
export * from "./ChartReport.vue?vue&type=script&lang=js"

import "./ChartReport.vue?vue&type=style&index=0&id=40bf485e&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bf485e"]])

export default __exports__